<template>
    <div class="customer-seas-detail-wrap">
        <div class="page-breadcrumb">
            <div class="company-info">
                <div class="logo-box"><img :src="details.logo" alt="" /></div>
                <h3>{{ details.company }}</h3>
            </div>
            <div class="operator-btns">
                <i class="iconfont icon-bianji" @click="handleClickEdit" v-if="is_admin">编辑</i>
                <i class="iconfont icon-fenpei" @click="handleClickAllocation" v-if="is_admin">分配</i>
                <el-dropdown placement="bottom-end" trigger="click">
                    <i class="iconfont el-icon-more">更多</i>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native="handleClickApply"> 申领 </el-dropdown-item>
                        <el-dropdown-item @click.native="handleClickTransfer" v-if="is_admin"> 转移 </el-dropdown-item>
                        <el-dropdown-item @click.native="handleClickShare" v-if="is_admin"> 分享 </el-dropdown-item>
                        <el-dropdown-item @click.native="handleClickDel" v-if="is_admin"> 删除 </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <div class="page-content">
            <div class="page-content-left" v-loading="contentLoading">
                <div class="tab-item-header">
                    <span>客户信息</span>
                </div>
                <div>
                    <CustomFormDetailPc
                        v-if="editDetailsShow"
                        :field_list="formInfoList"
                        :form_detail="customerDetail"
                        :pk_id="Number(customer_id)"
                        :is_edit_mode="false"
                        :is_detail_not_edit_mode="true"
                    />
                </div>
            </div>
            <div class="page-content-middle">
                <div class="middle-tab-card middle-tab-card1">
                    <div class="tab-item-header">
                        <span>客户摘要</span>
                    </div>

                    <el-row :gap="24">
                        <el-col :span="24">
                            <span>商机数量：</span>
                            <span
                                >总{{ customerSummaryData.project && customerSummaryData.project.project_count }}/赢{{
                                    customerSummaryData.project && customerSummaryData.project.project_win
                                }}/输{{
                                    customerSummaryData.project && customerSummaryData.project.project_failed
                                }}</span
                            >
                        </el-col>
                        <el-col :span="12">
                            <span>订单数量：</span>
                            <span>{{ customerSummaryData.order_count }}单</span>
                        </el-col>
                        <el-col :span="12">
                            <span>订单总额：</span>
                            <span>{{ customerSummaryData.total_order_amount }}元</span>
                        </el-col>
                        <el-col :span="12">
                            <span>已回款金额：</span>
                            <span>{{ customerSummaryData.total_repaid_amount }}元</span>
                        </el-col>
                        <el-col :span="12">
                            <span>未回款金额：</span>
                            <span>{{ customerSummaryData.total_unrepaid_amount }}元</span>
                        </el-col>
                    </el-row>
                </div>
                <div class="middle-tab-card middle-tab-card2" v-loading="dynamicLoading">
                    <div class="tab-item-header">
                        <span>客户动态</span>
                        <el-popover
                            ref="filterFormPopover"
                            placement="bottom-end"
                            title=""
                            width="360"
                            trigger="click"
                            :visible-arrow="false"
                        >
                            <div class="dynamic-filter-popper">
                                <p>筛选</p>
                                <div>
                                    <p>类型</p>
                                    <el-select
                                        v-model="dynamicFilterForm.type"
                                        placeholder="请选择"
                                        size="small"
                                        @change="customerLogFilter"
                                    >
                                        <el-option
                                            v-for="item in logTypeOptions"
                                            :key="item.value"
                                            :label="item.title"
                                            :value="item.value"
                                        >
                                        </el-option>
                                    </el-select>
                                </div>
                                <div>
                                    <p>时间</p>
                                    <el-date-picker
                                        v-model="dynamicFilterForm.dateRange"
                                        type="daterange"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                        size="small"
                                        format="yyyy-MM-dd"
                                        value-format="yyyy-MM-dd"
                                        @change="customerLogFilter"
                                    >
                                    </el-date-picker>
                                </div>
                            </div>
                            <span class="filter-icon" slot="reference"><i class="iconfont icon-shaixuan"></i>筛选</span>
                        </el-popover>
                    </div>
                    <div class="dynamic-list">
                        <ul
                            :infinite-scroll-delay="100"
                            :infinite-scroll-immediate="false"
                            v-infinite-scroll="customerLogLoadMore"
                        >
                            <li class="dynamic-item" v-for="item in dynamicList" :key="item.id">
                                <div class="dynamic-item-title">
                                    <PersonnelCard :userId="item.log_user.id" v-if="item.log_user && item.log_user.id">
                                        <template slot="container">
                                            <div class="user-avatar-btn">
                                                <img
                                                    :src="
                                                        item.log_user && item.log_user.avatar
                                                            ? item.log_user.avatar
                                                            : defaultImg
                                                    "
                                                    alt=""
                                                />
                                                <span class="dynamic-item-name">{{
                                                    item.log_user && item.log_user.name
                                                }}</span>
                                            </div>
                                        </template>
                                    </PersonnelCard>
                                    <span class="dynamic-item-time">{{ item.created_date }}</span>
                                    <span
                                        v-if="dynamicTypeTagList.includes(item.type)"
                                        :class="['dynamic-tag', 'dynamic-tag-' + item.type]"
                                        >{{ item.type_name }}</span
                                    >
                                </div>
                                <div class="dynamic-item-content">
                                    <template v-if="item.type == 'project_add'">
                                        <template v-if="item.content && item.content.content">
                                            <span
                                                class="link-label"
                                                @click="
                                                    handleClickBusinessDetail(
                                                        item.relate_id,
                                                        item.content.content.project_name
                                                    )
                                                "
                                                >{{ item.content.content.project_name }}</span
                                            >
                                            <span>{{ item.content.content.project_stage_name }}</span>
                                        </template>
                                    </template>
                                    <template v-else-if="item.type == 'new_work_order'">
                                        <span class="link-label">{{
                                            item.content && item.content.content && item.content.content.workorder_num
                                        }}</span>
                                        <span>{{
                                            item.content &&
                                            item.content.content &&
                                            item.content.content.workorder_status_text
                                        }}</span>
                                        <span>{{
                                            item.content &&
                                            item.content.content &&
                                            item.content.content.workorder_type_text
                                        }}</span>
                                    </template>
                                    <template v-else-if="item.type == 'order_add'">
                                        <span
                                            class="link-label"
                                            @click="handleClickLogOrderDetail(item.content && item.content.content)"
                                            >{{
                                                item.content && item.content.content && item.content.content.order_num
                                            }}</span
                                        >
                                        <span
                                            >{{
                                                item.content &&
                                                item.content.content &&
                                                item.content.content.salesperson &&
                                                item.content.content.salesperson.name
                                            }}
                                        </span>
                                        <span
                                            >¥{{
                                                item.content && item.content.content && item.content.content.total_price
                                            }}</span
                                        >
                                    </template>
                                    <template v-else-if="item.type == 'manage'">
                                        <p>{{ item.content && item.content.content }}</p>
                                        <template
                                            v-if="item.is_open && item.extendDetail"
                                            v-loading="manageCustomerDetailLoading"
                                        >
                                            <CustomFieldsDetailForm
                                                :details="item.extendDetail"
                                                :field_table="'customer_manages'"
                                                :filter_system="true"
                                                :form_label_position="'left'"
                                                :form_label_suffix="'：'"
                                                :custom_form_class="'manage_customer_form'"
                                                @loading-change="manageCustomerDetailLoadingChange"
                                                v-if="item.is_open"
                                            ></CustomFieldsDetailForm>
                                        </template>
                                        <div
                                            class="is-collapsed-down"
                                            :class="{ 'is-collapsed-up': item.is_open }"
                                            @click="handleClickCollapsed(item)"
                                        >
                                            <span>{{ item.is_open ? "收起" : "展开" }}</span
                                            ><img
                                                src="https://download.hecoos.com/enlightv/2024-45/5dcd224158f9ca176d74045d01d456e8.png"
                                                alt=""
                                            />
                                        </div>
                                    </template>
                                    <template v-else-if="item.type == 'change'">
                                        <span>客户等级：</span>
                                        <span>A级—B级</span>
                                    </template>
                                    <template v-else-if="item.type == 'follow_up'">
                                        <p>
                                            {{ item.content && item.content.content }}
                                        </p>
                                        <div class="is-collapsed-down" @click="handleClickFollowRecordDetail(item)">
                                            <span>详情</span
                                            ><img
                                                src="https://download.hecoos.com/enlightv/2024-45/d773cf7f7e8c2899137cf875c60da210.png"
                                                alt=""
                                            />
                                        </div>
                                    </template>
                                    <template v-else>
                                        <template v-if="item.type_detail == 'edit_customer'">
                                            <span>{{ item.type_name }}</span>
                                        </template>
                                        <span v-else>{{ item.content && item.content.content }}</span>
                                    </template>
                                </div>
                            </li>
                        </ul>
                        <div class="detail-no-data-wrap" v-if="!dynamicList.length">
                            <p>暂无数据</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="page-content-right">
                <ul>
                    <el-popover
                        placement="left"
                        title=""
                        width="360"
                        trigger="hover"
                        :visible-arrow="false"
                        popper-class="custom-tab-popper custom-tab-popper-personnel"
                    >
                        <div class="custom-tab-popper-wrap">
                            <div class="custom-tab-popper-title custom-tab-popper-title1">
                                <span>联系人（{{ contactList.length }}）</span>
                                <el-button
                                    type="text"
                                    class="link-label"
                                    v-if="is_admin"
                                    @click="handleClickAddCrmContact"
                                    ><i class="iconfont icon-tianjia1"></i>新增联系人</el-button
                                >
                            </div>
                            <div
                                class="custom-tab-popper-content custom-tab-popper-personnel-content"
                                v-loading="contactLoading"
                            >
                                <ul v-if="contactList.length">
                                    <li v-for="(item, index) in contactList" :key="index">
                                        <span class="link-label ellipsis" @click="handleClickPersonnelDetail(item)">{{
                                            item.name
                                        }}</span>
                                        <span>{{ item.phone ? phoneEncryption(item.phone) : "" }}</span>
                                    </li>
                                </ul>
                                <div class="detail-no-data-wrap" v-else>
                                    <p>暂无数据</p>
                                </div>
                            </div>
                        </div>
                        <li slot="reference">
                            <img :src="tabList[0].icon" alt="联系人" />
                            <span>{{ tabList[0].label }}</span>
                        </li>
                    </el-popover>
                    <el-popover
                        placement="left"
                        title=""
                        width="360"
                        trigger="hover"
                        :visible-arrow="false"
                        popper-class="custom-tab-popper custom-tab-popper-order"
                    >
                        <div class="custom-tab-popper-wrap">
                            <div class="custom-tab-popper-title">
                                <span>关联订单（{{ orderPagination.total }}）</span>
                            </div>
                            <div
                                class="custom-tab-popper-content custom-tab-popper-order-content"
                                v-loading="orderListLoading"
                            >
                                <ul
                                    v-infinite-scroll="relatedOrderListLoadMore"
                                    :infinite-scroll-delay="100"
                                    :infinite-scroll-immediate="false"
                                    infinite-scroll-distance="20"
                                >
                                    <li v-for="(item, index) in relatedOrderList" :key="index" class="order-item">
                                        <div class="order-item-title">
                                            <span class="link-label ellipsis" @click="handleClickOrderDetail(item)">{{
                                                item.order_num
                                            }}</span>
                                            <span>{{ item.created_at }}</span>
                                        </div>
                                        <div class="order-item-content">
                                            <PersonnelCard
                                                :userId="item.salesperson.id"
                                                v-if="item.salesperson && item.salesperson.id"
                                            >
                                                <template slot="container">
                                                    <div class="user-avatar-btn">
                                                        <img
                                                            alt=""
                                                            :src="
                                                                item.salesperson && item.salesperson.avatar
                                                                    ? item.salesperson.avatar
                                                                    : defaultImg
                                                            "
                                                        />
                                                        <span>{{ item.salesperson && item.salesperson.name }}</span>
                                                    </div>
                                                </template>
                                            </PersonnelCard>
                                            <span>¥{{ item.total_price }}</span>
                                        </div>
                                    </li>
                                </ul>
                                <!-- <div class="detail-no-data-wrap" v-else>
                                    <p>暂无数据</p>
                                </div> -->
                            </div>
                        </div>
                        <li slot="reference">
                            <img :src="tabList[1].icon" alt="订单" />
                            <span>{{ tabList[1].label }}</span>
                        </li>
                    </el-popover>
                    <el-popover
                        placement="left"
                        title=""
                        width="360"
                        trigger="hover"
                        :visible-arrow="false"
                        popper-class="custom-tab-popper custom-tab-popper-business"
                    >
                        <div class="custom-tab-popper-wrap">
                            <div class="custom-tab-popper-title">
                                <span>关联商机（{{ projectsPagination.total }}）</span>
                            </div>
                            <div
                                class="custom-tab-popper-content custom-tab-popper-business-content"
                                v-loading="projectsListLoading"
                            >
                                <ul 
                                    v-infinite-scroll="relatedProjectsLoadMore"
                                    :infinite-scroll-delay="100"
                                    :infinite-scroll-immediate="false"
                                    infinite-scroll-distance="20">
                                    <li v-for="(item, index) in relatedProjectsList" :key="index" class="business-item">
                                        <span
                                            class="link-label ellipsis"
                                            @click="handleClickBusinessDetail(item.id, item.name)"
                                            >{{ item.name }}</span
                                        >
                                        <span>{{ item.stage_detail && item.stage_detail.name }}</span>
                                    </li>
                                </ul>
                                <!-- <div class="detail-no-data-wrap" v-else>
                                    <p>暂无数据</p>
                                </div> -->
                            </div>
                        </div>
                        <li slot="reference">
                            <img :src="tabList[2].icon" alt="商机" />
                            <span>{{ tabList[2].label }}</span>
                        </li>
                    </el-popover>
                    <el-popover
                        placement="left"
                        title=""
                        width="360"
                        trigger="hover"
                        :visible-arrow="false"
                        popper-class="custom-tab-popper custom-tab-popper-work"
                    >
                        <div class="custom-tab-popper-wrap">
                            <div class="custom-tab-popper-title">
                                <span>关联工单（{{ workOrderPagination.total }}）</span>
                            </div>
                            <div
                                v-loading="workOrderListLoading"
                                class="custom-tab-popper-content custom-tab-popper-work-content"
                            >
                                <ul
                                    v-infinite-scroll="workOrderListLoadMore"
                                    :infinite-scroll-delay="100"
                                    :infinite-scroll-immediate="false"
                                    infinite-scroll-distance="20"
                                >
                                    <li v-for="(item, index) in relatedWorkOrderList" :key="index" class="work-item">
                                        <div class="work-item-title">
                                            <div>
                                                <span
                                                    class="link-label ellipsis"
                                                    @click="handleClickWorkOrderDetail(item)"
                                                    >{{ item.workorder_num }}</span
                                                >
                                                <span v-if="item.status === 6">{{ item.status_text }}</span>
                                            </div>
                                            <span>{{ item.created_at }}</span>
                                        </div>
                                        <div class="work-item-content">
                                            <span>{{ item.workorder_type_id && item.workorder_type_id.name }} </span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <li slot="reference">
                            <img :src="tabList[3].icon" alt="工单" />
                            <span>{{ tabList[3].label }}</span>
                        </li>
                    </el-popover>
                </ul>
            </div>
        </div>
        <el-dialog
            title=""
            :visible.sync="deleteCustomerDialog"
            v-if="deleteCustomerDialog"
            width="390px"
            :before-close="handledeleteCustomerDialogClose"
            :close-on-click-modal="false"
            class="custom-dialog custom-tooltip-confirm-dialog"
        >
            <div class="flex">
                <i class="dialog-left-icon iconfont icon-jinggao"></i>
                <div>
                    <p class="tooltip-confirm-title">您确定要删除吗？</p>
                    <p>删除后不可恢复，请谨慎操作！</p>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handledeleteCustomerDialogClose">取消</el-button>
                <el-button type="danger" @click="handledeleteCustomerConfirm">删除</el-button>
            </span>
        </el-dialog>
        <el-dialog
            v-if="relateCustomFormVisible"
            :before-close="handleClickCrmContactCancel"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :title="'新增关联联系人'"
            :visible.sync="relateCustomFormVisible"
            append-to-body
            custom-class="custom_form_dialog relate_custom_form_dialog"
            width="560px"
        >
            <div class="custom_form_body">
                <CustomFormPc
                    ref="relateCustomForm"
                    :field_list="relateCustomFormFields"
                    :pk_id="relate_form_id"
                    @submit-form="relateCustomerSummitFormData"
                >
                </CustomFormPc>
            </div>
            <div slot="footer">
                <el-button size="small" @click="handleClickCrmContactCancel">取消</el-button>
                <el-button :disabled="btnDisabled" size="small" type="primary" @click="handleClickCrmContactConfirm"
                    >保存
                </el-button>
            </div>
        </el-dialog>
        <FollowRecordDetails
            :followRecordDetailsVisible.sync="followRecordDetailsVisible"
            :followRecordId.sync="followRecordId"
            v-if="followRecordDetailsVisible"
        />
        <CustomerAllocation
            :allocationDialog.sync="allocationDialog"
            :selectedList.sync="selectedTableData"
            :sea_id="sea_id"
            @updateCallback="getCustomerPublicDetail"
            v-if="allocationDialog"
        />
        <CustomerTransfer
            :transferDialog.sync="transferDialog"
            :selectedList.sync="selectedTableData"
            :sea_id="sea_id"
            @updateCallback="handleTransferSuccess"
            v-if="transferDialog"
        />
        <CustomerApply :applyDialog.sync="applyDialog" :selectedList.sync="selectedTableData" v-if="applyDialog" />
        <CustomerAdd
            :addDialogVisible.sync="addDialogVisible"
            :editId="editId"
            addType="public"
            :sea_id="sea_id"
            @operateSuccessCallback="getCustomerPublicDetail"
            v-if="addDialogVisible"
        />
        <ShareDialog
            :shareDialog.sync="shareDialog"
            :shareCustomerId="customer_id"
            :shareCustomerName="details.company"
            v-if="shareDialog"
        />
        <PersonnelDetail
            :personnelDetailVisible.sync="personnelDetailVisible"
            :contactId="contactId"
            v-if="personnelDetailVisible"
        />
    </div>
</template>
<script>
import {
    GetContactList,
    GetCustomerPublicDetail,
    CustomerPublicDel,
    GetCustomerLogTypeList,
    GetCustomerLogList,
    getFormFields,
    ContactAdd,
    GetCompanySwitchList,
    CustomerSummary,
    CustomerRelateOrders,
    CustomerRelateProjects,
    GetHighSeasManagementList,
    getWorkOrderList,
    checkClaimNum,
    getOrderList,
    getProjectList,
} from "@/api";
import { phoneEncryption } from "@/utils";
import CustomerAllocation from "./component/customer_allocation.vue";
import CustomerTransfer from "./component/customer_transfer.vue";
import CustomerApply from "./component/customer_apply.vue";
import CustomerAdd from "./component/customer_add.vue";
import ShareDialog from "./component/share_dialog.vue";
import PersonnelCard from "@/components/pComponents/PersonnelCard.vue";
import PersonnelDetail from "@/components/pComponents/personnel_detail.vue";
import FollowRecordDetails from "./component/follow_record_details.vue";
import CustomFieldsDetailForm from "@/components/pComponents/CustomFieldsDetailForm.vue";
import CustomFormPc from "@/components/pComponents/CustomFormPc";
import CustomFormDetailPc from "@/components/pComponents/CustomFormDetailPc";
export default {
    name: "CustomerHighSeasDetail",
    components: {
        CustomerAllocation,
        CustomerTransfer,
        CustomerApply,
        CustomerAdd,
        ShareDialog,
        FollowRecordDetails,
        PersonnelCard,
        PersonnelDetail,
        CustomFieldsDetailForm,
        CustomFormDetailPc,
        CustomFormPc,
    },
    data() {
        return {
            customer_id: this.$route.query.customer_id,
            sea_id: this.$route.query.sea_id,
            is_admin: false, // 公海管理员：增删改查、申领、分配、分享、转移操作，公海成员：查看、申领
            defaultImg: require("@/assets/images/default.jpg"),
            contentLoading: false,
            formInfoList: [],
            customerDetail: {},
            editDetailsShow: true,
            details: {
                id: "",
                logo: "",
                company: "",
            },
            // 客户摘要信息
            customerSummaryData: {
                project: {},
                order_count: 0,
                total_order_amount: 0,
                total_repaid_amount: 0,
                total_unrepaid_amount: 0,
            },
            dynamicFilterForm: {
                type: "",
                dateRange: [],
                page: 1,
                total: 0,
                modelSwitch: {
                    customer_follow_ups: "",
                    customer_manages: "",
                },
            },
            logTypeOptions: [],
            dynamicLoading: false,
            dynamicTypeTagList: [
                "follow_up",
                "manage",
                "project_add",
                "order_add",
                "new_work_order",
                "customer_change",
            ],
            dynamicList: [],
            tabList: [
                {
                    name: "personnel",
                    label: "联系人",
                    icon: "https://download.hecoos.com/enlightv/2024-44/2fc84690f2728a31b692573b536c41d6.png",
                },
                {
                    name: "personnel",
                    label: "订单",
                    icon: "https://download.hecoos.com/enlightv/2024-44/f37ea85f5692a2dfb5bedbc45c4f1aa3.png",
                },
                {
                    name: "personnel",
                    label: "商机",
                    icon: "https://download.hecoos.com/enlightv/2024-44/fde5131248211d41bb8c0d2f719a5756.png",
                },
                {
                    name: "personnel",
                    label: "工单",
                    icon: "https://download.hecoos.com/enlightv/2024-44/ddd0ee97e996ec429fcccbbe7ac99f46.png",
                },
            ],
            contactLoading: false,
            contactList: [],
            orderPagination: {
                pageNum: 1,
                pageSize: 20,
                total: 0,
            },
            orderListLoading: false,
            relatedOrderList: [],
            projectsPagination: {
                pageNum: 1,
                pageSize: 20,
                total: 0,
            },
            projectsListLoading: false,
            relatedProjectsList: [],
            workOrderPagination: {
                pageNum: 1,
                pageSize: 20,
                total: 0,
            },
            workOrderListLoading: false,
            relatedWorkOrderList: [],

            followRecordDetailsVisible: false,
            editId: "", // 编辑客户
            addDialogVisible: false, // 添加、编辑
            allocationDialog: false, // 分配
            transferDialog: false, // 转移
            deleteCustomerDialog: false, // 删除
            applyDialog: false, // 申领
            selectedTableData: [], // 弹框需要
            shareDialog: false, // 分享
            followRecordId: "",
            followRecordDetailsVisible: false, // 跟进记录详情
            contactId: "", // 联系人id
            personnelDetailVisible: false, // 联系人详情
            relateCustomFormVisible: false, // 新增关联联系人弹框
            relateCustomFormFields: [],
            relate_form_id: 0,
            btnDisabled: false,
            phoneEncryption,
        };
    },
    created() {
        this.details.company = this.$route.query.name;
        this.getHighSeasManagementList();
        this.getCustomerPublicDetail();
    },
    methods: {
        //详情加载状态
        detailLoadingChange(loading) {
            this.contentLoading = loading;
        },
        // 获取公海列表
        getHighSeasManagementList() {
            GetHighSeasManagementList().then((res) => {
                if (res.code === 200) {
                    const highSeasList = res.data || [];
                    if (this.sea_id) {
                        const sea_item = highSeasList.find((item) => item.id === this.sea_id);
                        this.is_admin = sea_item ? sea_item.is_admin : false;
                    }
                }
            });
        },
        // 获取表单字段
        // _getFromFields() {
        //     getFormFields({
        //         field_form: "customers",
        //     })
        //         .then((res) => {
        //             if (res.code === 200) {
        //                 this.formInfoList = res.data || [];
        //             } else {
        //                 this.$message.error(res.message);
        //             }
        //         })
        //         .catch(() => {});
        // },
        // 获取客户详情
        getCustomerPublicDetail() {
            this.contentLoading = true;
            getFormFields({
                field_form: "customers",
            })
                .then((res) => {
                    if (res.code === 200) {
                        this.formInfoList = res.data.filter((item) => item.field_key !== "salesperson");
                    }
                    GetCustomerPublicDetail(this.customer_id).then((res) => {
                        if (res.code === 200) {
                            this.customerDetail = JSON.parse(JSON.stringify(res.data));
                            this.project_ids = this.customerDetail.project_ids;
                            this.order_ids = this.customerDetail.order_ids;
                            this.editDetailsShow = false;
                            this.$nextTick(() => {
                                this.editDetailsShow = true;
                            });
                            this.getCustomerSummary();
                            this.getContactList();
                            this.getCustomerLogTypeList();
                            this.getCompanySwitchList();
                            this.getCustomerRelateOrders();
                            this.getCustomerRelateProjects();
                            this.getCustomerRelateWorkOrderListData();
                        }
                        this.contentLoading = false;
                    });
                })
                .catch(() => {});
        },
        // 获取客户摘要
        getCustomerSummary() {
            const params = {
                customer_id: this.customer_id,
            };
            CustomerSummary(params).then((res) => {
                if (res.code === 200) {
                    this.customerSummaryData = res.data || {};
                }
            });
        },

        // 获取联系人列表
        getContactList() {
            this.contactLoading = true;
            GetContactList({ name: "", customer_id: this.customer_id }).then((res) => {
                if (res.code === 200) {
                    const { list, total } = res.data;
                    this.contactList = list || [];
                } else {
                    this.contactList = [];
                }
                this.contactLoading = false;
            });
        },
        // 初始化关联订单信息
        initRelateOrdersData() {
            this.orderPagination.pageNum = 1;
            this.orderPagination.total = 0;
            this.relatedOrderList = [];
            this.getCustomerRelateOrders();
        },
        // 加载更多订单信息
        relatedOrderListLoadMore() {
            if (this.orderListLoading || this.relatedOrderList.length == this.orderPagination.total) {
                return false;
            }
            this.orderPagination.pageNum += 1;
            this.getCustomerRelateOrders();
        },
        // 获取关联订单
        getCustomerRelateOrders() {
            this.orderListLoading = true;
            const params = {
                page: this.orderPagination.pageNum,
                pageSize: this.orderPagination.pageSize,
                keyword: "",
                customer_id: this.customer_id,
            };
            getOrderList(params).then((res) => {
                if (res.code === 200) {
                    const { data, total } = res.data;
                    let relatedOrderList = data.map((item) => {
                        item.created_at = item.created_at ? formatDate(item.created_at, "date") : item.created_at;
                        return item;
                    });
                    this.orderListLoading = false;
                    this.relatedOrderList = this.relatedOrderList.concat(relatedOrderList || []);
                    this.orderPagination.total = total;
                } else {
                    this.relatedOrderList = [];
                    this.orderListLoading = false;
                }
            });
        },
        // 初始化关联商机信息
        initRelateProjectsData() {
            this.projectsPagination.pageNum = 1;
            this.projectsPagination.total = 0;
            this.relatedProjectsList = [];
            this.getCustomerRelateProjects();
        },
        // 加载更多商机信息
        relatedProjectsLoadMore() {
            if (this.projectsListLoading || this.relatedProjectsList.length == this.projectsPagination.total) {
                return false;
            }
            this.projectsPagination.pageNum += 1;
            this.getCustomerRelateProjects();
        },
        // 获取关联商机
        getCustomerRelateProjects() {
            this.projectsListLoading = true;
            const params = {
                keyword: "",
                page: this.projectsPagination.pageNum,
                pageSize: this.projectsPagination.pageSize,
                customer_id: this.customer_id,
            };
            getProjectList(params).then((res) => {
                if (res.code === 200) {
                    const { data, total } = res.data;
                    this.projectsListLoading = false;
                    this.relatedProjectsList = this.relatedProjectsList.concat(data || []);
                    this.projectsPagination.total = total;
                } else {
                    this.projectsListLoading = false;
                    this.relatedProjectsList = [];
                }
            });
        },
        // 加载更多工单信息
        workOrderListLoadMore() {
            if (this.workOrderListLoading || this.relatedWorkOrderList.length == this.workOrderPagination.total) {
                return false;
            }
            this.workOrderPagination.pageNum += 1;
            this.getCustomerRelateWorkOrderListData();
        },
        // 获取关联工单
        getCustomerRelateWorkOrderListData() {
            this.workOrderListLoading = true;
            getWorkOrderList({
                page: this.workOrderPagination.pageNum,
                pageSize: this.workOrderPagination.pageSize,
                keyword: "",
                tab: "",
                project_id: this.project_ids,
                order_id: this.order_ids && this.order_ids.length ? this.order_ids.join(",") : "",
            }).then((res) => {
                if (res.code === 200) {
                    const { data, total } = res.data;
                    data.forEach((item) => {
                        this.$set(item, "workorder_id", item.id);
                    });
                    this.workOrderListLoading = false;
                    this.relatedWorkOrderList = this.relatedWorkOrderList.concat(data || []);
                    this.workOrderPagination.total = total;
                } else {
                    this.workOrderListLoading = false;
                }
            });
        },

        // 获取跟进记录和管理记录开发列表
        getCompanySwitchList() {
            GetCompanySwitchList().then((res) => {
                const data = res.data || [];
                data.forEach((item) => {
                    this.dynamicFilterForm.modelSwitch[item.type] = item.status;
                });
                this.customerLogFilter();
            });
        },
        // 获取日志类型
        getCustomerLogTypeList() {
            GetCustomerLogTypeList().then((res) => {
                if (res.code === 200) {
                    this.logTypeOptions = res.data || [];
                    this.logTypeOptions.unshift({ title: "全部", value: "" });
                }
            });
        },
        // 日志筛选
        customerLogFilter() {
            this.dynamicFilterForm.page = 1;
            this.dynamicFilterForm.total = 0;
            this.dynamicList = [];
            this.getCustomerLogList();
        },
        // 获取日志信息
        getCustomerLogList() {
            this.$refs.filterFormPopover && this.$refs.filterFormPopover.doClose();
            this.dynamicLoading = true;
            const params = {
                keyword: "",
                customer_id: this.customer_id,
                type: this.dynamicFilterForm.type,
                dateRange:
                    this.dynamicFilterForm.dateRange && this.dynamicFilterForm.dateRange.length
                        ? this.dynamicFilterForm.dateRange.join(" - ")
                        : "",
                page: this.dynamicFilterForm.page,
                pageSize: 10,
                modelSwitch: this.dynamicFilterForm.modelSwitch,
            };
            GetCustomerLogList(params).then((res) => {
                if (res.code === 200) {
                    const { list, total } = res.data;
                    this.dynamicList = this.dynamicList.concat(list || []);
                    this.dynamicFilterForm.total = Number(total);
                }
                this.dynamicLoading = false;
            });
        },
        // 加载更多日志信息
        customerLogLoadMore() {
            if (this.dynamicLoading || this.dynamicList.length == this.dynamicFilterForm.total) {
                return false;
            }
            this.dynamicFilterForm.page += 1;
            this.getCustomerLogList();
        },
        // 编辑
        handleClickEdit() {
            this.editId = this.customer_id;
            this.addDialogVisible = true;
        },
        // 分配
        handleClickAllocation() {
            this.selectedTableData = [{ id: this.customer_id, name: { value: this.details.company } }];
            this.allocationDialog = true;
        },
        // 申领
        handleClickApply() {
            this.selectedTableData = [{ id: this.customer_id, name: { value: this.details.company } }];
            checkClaimNum({ sea_id: this.sea_id, customer_ids: this.selectedTableData.map((item) => item.id) }).then(
                (res) => {
                    if (res.code === 200) {
                        this.applyDialog = true;
                    } else {
                    }
                }
            );
        },
        // 转移
        handleClickTransfer() {
            this.selectedTableData = [{ id: this.customer_id, name: { value: this.details.company } }];
            this.transferDialog = true;
        },
        // 分享
        handleClickShare() {
            this.shareDialog = true;
        },
        // 转移成功
        handleTransferSuccess() {
            this.$router.go(-1);
        },
        // 删除
        handleClickDel(row) {
            this.deleteCustomerDialog = true;
        },
        handledeleteCustomerDialogClose() {
            this.deleteCustomerDialog = false;
        },
        handledeleteCustomerConfirm() {
            CustomerPublicDel({ customer_ids: [this.customer_id] }).then((res) => {
                if (res.code === 200) {
                    this.$message.success(res.message);
                    this.deleteCustomerDialog = false;
                    this.$router.go(-1);
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        // 查看联系人详细信息
        handleClickPersonnelDetail({ id }) {
            this.contactId = Number(id);
            this.personnelDetailVisible = true;
        },
        // 新增客户联系人
        handleClickAddCrmContact() {
            getFormFields({
                field_form: "customer_contacts",
            })
                .then((res) => {
                    if (res.code === 200) {
                        this.relateCustomFormFields = res.data;
                        this.relateCustomFormVisible = true;
                    } else {
                        this.$message.error(res.message);
                    }
                })
                .catch(() => {});
        },
        //新增客户联系人取消事件
        handleClickCrmContactCancel() {
            this.relateCustomFormVisible = false;
            this.relate_form_id = 0;
        },

        //新增客户联系人确认事件
        handleClickCrmContactConfirm() {
            this.$refs.relateCustomForm.handleClickPublish();
        },
        // 新增联系人提交
        relateCustomerSummitFormData(customForm) {
            if (customForm) {
                ContactAdd({ customer_id: this.customer_id, ...customForm })
                    .then((res) => {
                        if (res.code === 200) {
                            this.$message.success(res.message);
                            this.handleClickCrmContactCancel();
                            this.getCustomerPublicDetail();
                            this.btnDisabled = false;
                        } else {
                            this.$message.error(res.message);
                        }
                    })
                    .catch(() => {});
            }
        },

        // 展开和收起
        async handleClickCollapsed(item) {
            this.manageCustomerDetailLoading = true;
            if (!item.hasOwnProperty("is_open")) {
                await this.getCustomerManageDetail(item);
                this.$set(item, "is_open", true);
            } else {
                item.is_open = !item.is_open;
            }
        },
        manageCustomerDetailLoadingChange(loading) {
            this.manageCustomerDetailLoading = loading;
        },
        // 查看跟进记录详情
        handleClickFollowRecordDetail(item) {
            this.followRecordId = item.relate_id;
            this.followRecordDetailsVisible = true;
        },
        // 查看管理记录详情
        getCustomerManageDetail(item) {
            GetCustomerManageDetail(item.relate_id).then((res) => {
                if (res.code === 200) {
                    this.$set(item, "extendDetail", res.data || {});
                }
            });
        },
        //点击查看商机详情
        handleClickBusinessDetail(project_id, name) {
            this.$router.push({
                name: "BusinessDetail",
                params: {
                    isPush: true,
                },
                query: {
                    project_id: project_id,
                    name: name,
                },
            });
        },
        // 订单详情
        handleClickOrderDetail(row) {
            this.$router.push({
                name: "OrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    order_id: row.id ? row.id : undefined,
                    order_num: row.order_no ? row.order_no : undefined,
                    name: row.order_num ? row.order_num : row.order_no,
                    query_type: row.id ? undefined : "order_num",
                },
            });
        },
        // 查看日志中的订单详情
        handleClickLogOrderDetail(row) {
            this.$router.push({
                name: "OrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    order_id: row.id ? row.id : undefined,
                    order_num: row.order_num ? row.order_num : undefined,
                    name: row.order_num ? row.order_num : row.order_no,
                    query_type: row.id ? undefined : "order_num",
                },
            });
        },
        //工单详情
        handleClickWorkOrderDetail(row) {
            this.$router.push({
                name: "WorkOrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    work_order_id: row.id,
                    name: row.workorder_num,
                },
            });
        },
    },
};
</script>
<style lang="scss">
@import "@/styles/customer-seas-detail.scss";
.relate_custom_form_dialog {
    .el-dialog__body {
        max-height: 492px;
        overflow-y: scroll;
    }
}
</style>
